import React, { ReactElement, useState } from 'react';

export interface SigmaFrameProps {
  src: string;
}

export const SigmaFrame = (props: SigmaFrameProps): ReactElement => {
  const { src } = props;
  const [height, setHeight] = useState(0);

  return (
    <iframe
      src={src}
      style={{
        display: 'block',
        height,
        width: '100%'
      }}
      ref={el => {
        if (el) {
          setHeight(window.innerHeight - el.offsetTop);
        }
      }}
    />
  );
};
